import { getOrderHighlightFieldValues } from '../../utils/orderHighlightDetailsUtils';
import ContactEmail from '../HighlightCard/HighlightDetails/ContactEmail';
import CreatedDate from '../HighlightCard/HighlightDetails/CreatedDate';
import CustomerName from '../HighlightCard/HighlightDetails/CustomerName';
import Field from '../HighlightCard/HighlightDetails/atomic/Field';
import Phone from '../HighlightCard/HighlightDetails/Phone';
import Pipeline from '../HighlightCard/HighlightDetails/Pipeline';
import Stage from '../HighlightCard/HighlightDetails/Stage';
import { ORDER_HIGHLIGHT_DETAILS } from '../../constants/dataTestIds';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const OrderHighlightDetails = ({
  properties,
  pipelines
}) => {
  const {
    createdDate,
    email,
    firstName,
    lastName,
    phone,
    pipeline,
    stage
  } = getOrderHighlightFieldValues({
    properties,
    pipelines
  });
  return /*#__PURE__*/_jsxs("div", {
    className: "text-left m-y-4",
    "data-test-id": ORDER_HIGHLIGHT_DETAILS,
    children: [/*#__PURE__*/_jsx(CreatedDate, {
      value: createdDate
    }), /*#__PURE__*/_jsx(Stage, {
      value: stage
    }), /*#__PURE__*/_jsx(Pipeline, {
      value: pipeline
    }), /*#__PURE__*/_jsx(Phone, {
      value: phone
    }), /*#__PURE__*/_jsx(ContactEmail, {
      value: email
    }), /*#__PURE__*/_jsx(CustomerName, {
      value: {
        firstName,
        lastName
      }
    }), /*#__PURE__*/_jsx(Field, {})]
  });
};
export default OrderHighlightDetails;